import { render, staticRenderFns } from "./ResourceHubDropdown.vue?vue&type=template&id=5ecf01c8&scoped=true&"
import script from "./ResourceHubDropdown.vue?vue&type=script&setup=true&lang=js&"
export * from "./ResourceHubDropdown.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ResourceHubDropdown.vue?vue&type=style&index=0&id=5ecf01c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecf01c8",
  null
  
)

export default component.exports